import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../route/index.js";
import auth from "@/api/auth";

import packageJson from "../../package.json";

import users from "./users.module";
import js_report from "./js_report.module";
import fleet from "./fleet.module";
import roles from "./roles.module";
import notifications from "./notifications.module";
import activityTypeRoles from "./activityTypeRoles.module";
import permissions from "./permissions.module";
import customers from "./customers.module";
import settings from "./settings.module";
import orders from "./orders.module";
import report from "./report.module";
import company from "./company.module";
import auditlogs from "./auditlogs.module";

import itemType from "./itemType.module";
import orderType from "./orderType.module";

import assets from "./assets.module";
import locations from "./locations.module";

import masterItem from "./masterItem.module";
import orderCategory from "./orderCategory.module";
import orderTemplate from "./orderTemplate.module";
import s3files from "./s3files.module";
import customerPortal from "./customerPortal.module.js";

import requestCategory from "./requestCategory.module";
import interactionType from "./interactionType.module";
import customerAgents from "./customerAgents.module";
import progressStatus from "./progressStatus.module";
import checkoffTemplates from "./checkoffTemplates.module";
import checkoffTypes from "./checkoffTypes.module";
import additionalField from "./additionalField.module";
import customerSegments from "./customerSegments.module";
import lifecycleStage from "./lifecycleStage.module";
import customerGroups from "./customerGroups.module";

import transactionType from "./transactionType.module";
import orderItemStore from "./orderItemStore.module";

import orderAttachmentsStore from "./orderAttachmentsStore.module";
import customerAttachmentsStore from "./customerAttachmentsStore.module";
import companyAttachmentsStore from "./companyAttachmentsStore.module";
import orderMessagesStore from "./orderMessagesStore.module";
import siteAdmin from "./siteAdmin.module";
import quickbook from "./quickbook.module";
import analytics from "./analytics.module";
import synchronizer from "./synchronizer.module.js";

Vue.use(Vuex);
const SECRET_KEY =
  "eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTcwMzE1NDgxMywiaWF0IjoxNzAzMTU0ODEzfQ.u80RU8sfK3TPOj2ggICN0Qgh5jNvc6H97jMlwzUG484";
export default new Vuex.Store({
  modules: {
    users,
    js_report,
    siteAdmin,
    fleet,
    notifications,
    roles,
    activityTypeRoles,
    permissions,
    customers,
    settings,
    orders,
    additionalField,
    report,
    auditlogs,
    company,
    orderType,
    transactionType,
    customerAgents,
    itemType,
    assets,
    locations,
    masterItem,
    orderCategory,
    orderTemplate,
    s3files,
    customerPortal,
    requestCategory,
    interactionType,
    progressStatus,
    customerSegments,
    lifecycleStage,
    customerGroups,
    checkoffTemplates,
    checkoffTypes,
    orderItemStore,
    orderAttachmentsStore,
    customerAttachmentsStore,
    companyAttachmentsStore,
    orderMessagesStore,
    quickbook,
    analytics,
    synchronizer,
  },
  state: {
    user: {},
    activity_type_permissions: [],
    rolePermissions: [],
    isAdmin: false,
    isBlacklisted: false,
    token: null,
    environment: null,
    user_customers: [],
    expires: null,
    verified: false,
    logging_out: false,
    SECRET_KEY: SECRET_KEY,
    web_version: null,
    api_version: null,
  },
  getters: {
    authenticated: (state) => !!state.token,
    user_permissions: (state) =>
      (state.rolePermissions || []).filter((x) => x.slug).map((x) => x.slug),
    isAdmin: (state) =>
      state.rolePermissions.length > 0 && state.user_customers.length === 0,
    isBlacklisted: (state) => state.user.is_blacklisted,
    userCustomers: (state) => state.user_customers.map((x) => x.customer),
    mediaBaseUrl: (state) => {
      let { web_domain, has_virus_check } = state.environment || {};
      let media_url;
      if (has_virus_check) {
        if (web_domain.indexOf("localhost") >= 0) {
          web_domain = Vue.prototype.$DEV_URL;
        }
        media_url = `https://${web_domain}/${Vue.prototype.$MediaPrefix}`;
      } else {
        media_url = Vue.prototype.$OMSStorageUrl;
      }
      return media_url;
    },
    web_domain: (state) => {
      let { web_domain } = state.environment || {};
      if (web_domain.indexOf("localhost") >= 0) {
        web_domain = Vue.prototype.$DEV_URL;
      }
      return web_domain;
    },
    baseURL: (state) => state?.environment?.api_server,
    is_development: (state) => !!state?.environment?.is_development,
    js_report_lambda_name: (state) => state?.environment?.js_report_lambda_name,
  },
  mutations: {
    PROFILE_PICTURE(state, payload) {
      state.user.profile_image = payload;
    },
    VERIFY_PASSWORD(state, verified) {
      state.verified = verified;
    },
    AUTHENTICATE(
      state,
      {
        token,
        user,
        rolePermissions,
        activity_type_permissions,
        user_customers,
        isAdmin,
        expires,
      }
    ) {
      state.token = token;
      state.rolePermissions = rolePermissions || [];
      state.user = user;
      state.user_customers = user_customers || [];
      state.isAdmin = isAdmin;
      state.expires = expires;
      state.activity_type_permissions = activity_type_permissions || [];
    },

    UNAUTHENTICATE(state) {
      state.token = null;
      state.rolePermissions = [];
      state.user_customers = [];
      state.user = {};
    },
    SET_ENVIRONMENT(state, environment) {
      state.environment = environment;
    },
    SET_LOGGING_OUT(state, x) {
      state.logging_out = !!x;
    },
    SET_WEB_VERSION(state, x) {
      state.web_version = x;
    },
    SET_API_VERSION(state, x) {
      state.api_version = x;
    },
  },
  actions: {
    async getBaseURL({ commit }) {
      try {
        let servers;
        let omsServers = Vue.prototype.$secureStorage.getItem("oms-servers");
        if (!omsServers) {
          const {
            data: { Items },
          } = await axios.get(this._vm.$OMSServersUrl);
          servers = Items;
          Vue.prototype.$secureStorage.setItem("oms-servers", servers);

          const { host } = window.location;
          const env = servers?.find((x) => x?.web_domain === host);

          commit("SET_ENVIRONMENT", env);
        } else {
          const servers = Vue.prototype.$secureStorage.getItem("oms-servers");

          const { host } = window.location;
          const env = servers?.find((x) => x?.web_domain === host);

          commit("SET_ENVIRONMENT", env);
        }

        const { host } = window.location;
        const env = servers.find((x) => x.web_domain === host);
        commit("SET_ENVIRONMENT", env);
      } catch (error) {
        console.log("getBaseURL error", error);
      }
    },

    getToken({ commit, dispatch }) {
      try {
        const accessToken = Vue.prototype.$secureStorage.getItem("accessToken");
        if (!accessToken) throw new Error("No Token Found");
        const {
          token,
          user,
          rolePermissions,
          activity_type_permissions,
          user_customers,
          expires,
          isAdmin,
        } = JSON.parse(accessToken);

        console.log("activity_type_permissions:", activity_type_permissions);

        axios.defaults.user = user;
        axios.defaults.rolePermissions = rolePermissions;
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        commit("AUTHENTICATE", {
          token,
          user,
          rolePermissions,
          activity_type_permissions,
          user_customers,
          expires,
          isAdmin,
        });
        dispatch("transactionType/fetchOptions", null, { root: true });
      } catch (err) {
        console.log("getToken", err);
        if (!JSON.parse(Vue.prototype.$secureStorage.getItem("accessToken"))) {
          commit("UNAUTHENTICATE");
          Vue.prototype.$secureStorage.clear();
          router.push("/login");
        }
      }
    },

    changePassword({ commit }, data) {
      return auth
        .changePassword(data)
        .then(() => {
          commit("VERIFY_PASSWORD", true);
        })
        .catch((error) => {
          throw error;
        });
    },

    checkPassword({ commit, state }, password) {
      console.log("user", state.user);
      const email = state.user.email;
      return auth
        .login(email, password)
        .then((resp) => {
          const { user } = resp.data.success.data;
          commit("VERIFY_PASSWORD", user.email === email);
        })
        .catch((error) => {
          console.log("error", error);
          commit("VERIFY_PASSWORD", false);
        });
    },

    async login({ commit, dispatch }, { email, password }) {
      return await auth
        .login(email, password)
        .then((resp) => {
          localStorage.removeItem("session_expired");
          const {
            token,
            user,
            expires,
            isAdmin,
            permissions: rolePermissions,
            activity_type_permissions,
            customers: user_customers,
          } = resp.data.success.data;
          console.log("activity_type_permissions:", activity_type_permissions);
          //let token = data.success.data.token

          // commit('authenticated', user)
          axios.defaults.user = user;
          axios.defaults.rolePermissions = rolePermissions;
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          const storeToken = JSON.stringify({
            token,
            user,
            expires,
            isAdmin,
            activity_type_permissions,
            rolePermissions,
            user_customers,
          });

          Vue.prototype.$secureStorage.setItem("accessToken", storeToken);

          // localStorage.setItem(
          //     'rolePermissions',
          //     JSON.stringify(rolePermissions)
          // )
          // localStorage.setItem('accessUser', JSON.stringify(user))
          //Define The Users Access Permissions
          // --------------------------------------------------

          commit("AUTHENTICATE", {
            token,
            user,
            activity_type_permissions,
            rolePermissions,
            expires,
            isAdmin,
            user_customers,
          });

          dispatch("transactionType/fetchOptions", null, {
            root: true,
          });
        })
        .catch((error) => {
          throw error;
        });
    },
    profilePicture({ commit, state }, payload) {
      const value = { id: state.user.id, profile_image: payload };
      return auth
        .uploadProfilePicture(value)
        .then(() => {
          commit("PROFILE_PICTURE", value.profile_image);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    customerLogin({ commit, dispatch }, { email, password }) {
      return auth
        .customerLogin(email, password)
        .then((resp) => {
          const {
            token,
            user,
            expires,
            isAdmin,
            customers: user_customers,
          } = resp.data.success.data;
          // commit('authenticated', user)
          axios.defaults.user = user;
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          const storeToken = JSON.stringify({
            token,
            user,
            expires,
            isAdmin,
            user_customers,
          });

          Vue.prototype.$secureStorage.setItem("accessToken", storeToken);
          commit("AUTHENTICATE", {
            token,
            user,
            expires,
            isAdmin,
            user_customers,
          });

          dispatch("transactionType/fetchOptions", null, {
            root: true,
          });
        })
        .catch((error) => {
          throw error;
        });
    },

    async logout({ commit }) {
      try {
        commit("SET_LOGGING_OUT", true);
        await auth.logout();
        commit("UNAUTHENTICATE");
        Vue.prototype.$secureStorage.clear();
        axios.defaults.headers.common["Authorization"] = "";
        router.push("/login");
        // location.reload(true);
      } catch (err) {
        console.error("logout", err);
      } finally {
        commit("SET_LOGGING_OUT", false);
      }
    },
    async getVersions({ commit }) {
      try {
        const {
          data: {
            success: { data },
          },
        } = await axios.get("auth/version");
        commit("SET_WEB_VERSION", packageJson.version);
        commit("SET_API_VERSION", data);
      } catch (err) {
        console.error("logout", err);
        commit("SET_WEB_VERSION", "");
        commit("SET_API_VERSION", "");
      }
    },
  },
});
